import styled from 'styled-components';
import {spacing} from '../../styles/vars';

type FlexColumnProps = {
  gap?: string;
};

export const FlexColumn = styled.div<FlexColumnProps>`
  display: flex;
  flex-direction: column;
  gap: ${props => props.gap ?? spacing.spacing02};
`;
